<h2 class="text-head">บิลที่บันทึกไว้</h2>
<form [formGroup]="orderDateForm" (ngSubmit)="getOrderByDate()">
    <label>วันที่</label>
    <input formControlName="date" type="date">
    <input type="submit" value="GO">
</form>
<div class="mat-elevation-z8 example-container">
    <table mat-table [dataSource]="dataSource">
        <!-- Name Column -->
        <ng-container matColumnDef="bill_name">
            <th mat-header-cell *matHeaderCellDef> ชื่อ </th>
            <td mat-cell *matCellDef="let element"> {{element.BillName}} </td>
        </ng-container>

        <!-- Time Create Column -->
        <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef> เวลา </th>
            <td mat-cell *matCellDef="let element"> {{element.Created | date:'M/d/yy, H:mm'}} </td>
        </ng-container>

        <!-- total Column -->
        <ng-container matColumnDef="total_price">
            <th mat-header-cell *matHeaderCellDef class="th-right"> ราคารวม </th>
            <td mat-cell *matCellDef="let element" class="th-right"> {{element.TotalPrice}} </td>
        </ng-container>

        <!-- total Column -->
        <ng-container matColumnDef="option">
            <th mat-header-cell *matHeaderCellDef class="th-right"> ตัวเลือก </th>
            <td mat-cell *matCellDef="let element" class="th-right">
                <mat-icon (click)="openDialog(element.bill_name,element.ID)">delete</mat-icon>
                <mat-icon (click)="selectOrder(element.ID)">open_in_new</mat-icon>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>